<template>
  <form @submit.prevent="onSubmit">
    <div class="flex flex-col pt-3 md:items-start md:flex-row md:justify-between">
      <TextInput
        v-model.trim="name"
        :disabled="locked"
        :label="tr('pages.sales.checkout.form.payment.cardholder.name')"
        :placeholder="tr('pages.sales.checkout.form.payment.cardholder.name')"
        extra-class="w-full mb-4 md:w-1/2 md:mr-4 xl:mb-6"
        :error="$v.name.$error ? tr('errors.type.required') : ''"
        @change="nameDirty = true"
      />

      <TextInput
        v-model.trim="email"
        :disabled="locked"
        :label="tr('pages.sales.checkout.form.payment.cardholder.email')"
        :placeholder="tr('pages.sales.checkout.form.payment.cardholder.email')"
        extra-class="w-full mb-4 md:w-1/2 xl:mb-6"
        :error="emailError"
        @change="emailDirty = true"
      />
    </div>

    <div class="py-5 md:py-0">
      <Button
        v-if="!locked"
        key="confirm"
        variant="primary"
        type="submit"
      >
        {{ tr('pages.sales.checkout.form.payment.cardholder.confirm2') }}
      </Button>
      <Button
        v-if="locked"
        key="unlock"
        variant="secondary"
        type="button"
        class="whitespace-no-wrap"
        @click="$emit('unlock')"
      >
        {{ tr('pages.sales.checkout.form.payment.cardholder.unlock') }}
      </Button>
    </div>
  </form>
</template>

<script>
import TextInput from '~brand-components/swiss/shared/text-input.vue'
import Button from '~brand-components/swiss/button/button.vue'
import Card3dsInformationForm from '~brand-components/base/sale/card-3ds-information-form.js'

export default Card3dsInformationForm.extend({
  components: {
    TextInput,
    Button,
  },

})
</script>
